export class PotwierdzKontoModel {
    kod: string;
}